import React from 'react';
import './ChildSelectionModal.css';

interface Child {
  player_id: number | null;
  player_name: string;
  relationship: string;
  evaluation: any | null;
  message?: string;
}

interface ChildSelectionModalProps {
  isOpen: boolean;
  children: Child[];
  onSelect: (child: Child) => void;
}

const ChildSelectionModal: React.FC<ChildSelectionModalProps> = ({
  isOpen,
  children,
  onSelect,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="child-selection-modal">
        <h3 className="modal-title">Select Child's Dashboard</h3>
        <p className="modal-message">You have multiple children linked to your account. Please select which child's dashboard you would like to view:</p>
        <div className="child-list">
          {children.map((child, index) => (
            <button
              key={index}
              className="child-button"
              onClick={() => onSelect(child)}
            >
              <div className="child-button-content">
                <span className="child-name">{child.player_name}</span>
                <span className="child-relationship">{child.relationship}</span>
                {child.evaluation ? (
                  <span className="child-status has-evaluation">✓ Has Evaluation</span>
                ) : (
                  <span className="child-status no-evaluation">{child.message || 'No evaluation yet'}</span>
                )}
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChildSelectionModal;























